export enum Routes {
  FinanceRouter = "*",
  OfferSearchPageRouter = "/finance/offer/search",
  OfferSaleCreatePageRouter = "/finance/offer/sale/new",
  OfferSaleEditPageRouter = "/finance/offer/:offerid/sale/edit",
  ContractSearchPageRouter = "/finance/contract/search",
  ContractSaleCreatePageRouter = "/finance/contract/sale/new",
  ContractSaleEditPageRouter = "/finance/contract/:contractid/sale/edit",
  InvoiceSearchPageRouter = "/finance/invoice/search",
  InvoiceCreatePageRouter = "/finance/invoice/new",
  InvoiceEditPageRouter = "/finance/invoice/:invoiceid/edit",
  DocumentSearchPageRouter = "/finance/documents/search",
  ExpenseSearchPageRouter = "/finance/expenses/search",
  UsageSearchPageRouter = "/finance/usage",
}
